export default "__VITE_ASSET__DFU0kKdJ__"